<template>
  <vs-table-m
    :total="data ? data.count || 0 : 0"
    :data="data ? data.results || [] : []"
    @selected="goToItemClicked"
    :class="`mt-10 ${relatedWithLowercase}-table`"
  >
    <template slot="header">
      <h4 class="m-2 my-4">{{ type }} where this {{ relatedWithLowercase }} appears</h4>
    </template>
    <template slot="thead">
      <vs-th
        v-for="col in visibleColumns"
        :key="col"
        :sort-key="columnConfig[col].sortKey"
      >{{ columnConfig[col].label }}</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td
          v-for="col in visibleColumns"
          :key="col"
          :data="columnConfig[col].data(tr)"
        >
          <template v-if="col === 'name'">
            {{ columnConfig[col].data(tr) }}
          </template>
          <template v-else-if="col === 'area'">
            <div class="flex" v-if="tr.learning_areas && tr.learning_areas.length">
              <div class="mr-5" v-for="la in tr.learning_areas" :key="la">
                <vs-chip transparent>
                  {{getLAreasEntries && getLAreasEntries[la] ? getLAreasEntries[la].name : ''}}
                </vs-chip>
              </div>
            </div>
          </template>
          <template v-else-if="col === 'modified'">
            {{ columnConfig[col].data(tr) | dateFromFormat }}
          </template>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table-m>
</template>
<script>
// Data Table with a few rows

import VsTableM from "@/components/VsTableM";
import { getBasicData } from '@/utils/mixins.js'

export default {
  components: {
    VsTableM
  },
  mixins: [getBasicData],
  props:{
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: String,
    relatedWith: {
      type: String,
      default: () => {
        return 'video'
      }
    }
  },
  computed: {
    relatedWithLowercase() {
      return this.relatedWith.toLowerCase()
    },
    columnsByRelatedWith() {
      return {
        default: ['name', 'area', 'modified'],
      }
    },
    visibleColumns() {
      return this.columnsByRelatedWith[this.relatedWithLowercase] || this.columnsByRelatedWith.default
    },
    columnConfig() {
      return {
        name: {
          label: 'Name',
          sortKey: 'name',
          data: (tr) => tr.name,
        },
        area: {
          label: 'Area',
          sortKey: 'name',
          data: (tr) => tr.learning_areas,
        },
        modified: {
          label: 'Modified',
          sortKey: 'name',
          data: (tr) => tr.modified,
        },
      }
    },
    getContentEditPath () {
      let path = ''
      switch (this.type) {
        case 'Courses':
          path = `edit-course`
          break;
        case 'Learning Paths':
          path = 'edit-lp'
          break;
      }
      return path
    },
  },
  methods: {
    goToItemClicked(e) {
      this.$router.push({name: this.getContentEditPath, params: {id: e.id}})
    },
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.collection-table {
  width: 100%;
}
</style>
